import { axios } from '@/plugins';

export default {
  async initChatSession({ commit, rootGetters }) {
    try {
      const endpoint = rootGetters['info/getLinks'].chatSessions;
      const {
        data: { chatSession },
      } = await axios.post(endpoint);

      commit('SET_CHAT_SESSION', chatSession);
    } catch (error) {
      throw error;
    }
  },

  async sendMessage({ getters, commit }, { message }) {
    try {
      commit('SET_MESSAGE', { text: message, sender: 'user' });
      const chatSession = getters.getChatSession;
      const {
        data: { chatMessage },
      } = await axios.post(chatSession.links.createMessage, {
        chatMessage: {
          action: 'knowledge_help',
          bodyText: message,
          agent: 'knowledge-help',
        },
      });
      commit('SET_MESSAGE', { text: chatMessage.body.text, sender: 'bot' });
    } catch (error) {
      throw error;
    }
  },
};
